<!-- 球队组件 -->
<template>
  <a-spin :spinning="dataLoading" v-if="contentVisible">
    <div class="titleDiv">
      <div></div>
      <p class="title">选择参赛队伍</p>
    </div>
    <div class="team">
      <div class="leaderData" v-if="teams && teams.length > 0">
        <div class="leader" v-for="(team, index) in teams" :key="index">
          <img class="coachHeader" :src="team.teamLogo || default_img" @click="choiceTeam(team.id)">
          <img class="coachHeader checked" v-if="curTeamId == team.id" src="@comm/assets/join/imgCheck.png" @click="choiceTeam(team.id)">
          <div style="margin:0 auto;text-align: center;">{{ getTeamName(team.teamName) }}</div>
        </div>
        <div class="leader">
          <img class="coachHeader" :src="addImg" @click="showDrawer()">
          <p style="text-align: center">点击新建队伍</p>
        </div>
      </div>
      <div style="margin-top: 85px;text-align:center;" v-else>
        <a-button type="primary" @click="showDrawer()">
          点击新建队伍
        </a-button>
      </div>
      <a-drawer
        placement="left"
        :closable="false"
        :visible="visible"
        :width="440"
        :get-container="false"
        :wrap-style="{ position: 'absolute' }"
        @close="onClose()">
        <a-spin :spinning="loading">
          <div class="drawerAddTeam">
            <div class="imgContainer">
              <Upload
                ref="upload"
                :length="1"
                :imgs="imgs"
                @uploadSuccess="uploadSuccess"
                :cutImg="true"
                uploadTest="点击更换logo"/>
            </div>
            <div>
              <div>
                <a-input style="width:280px;" v-model="teamName" :maxLength="5" placeholder="请输入队伍名称，最多五个字"/>
              </div>
              <div class="operContainer">
                <a-button size="small" type="primary" @click="submit()"> 确定 </a-button>
                <a-button size="small" class="cancel" @click="onClose()"> 取消 </a-button>
              </div>
            </div>
          </div>
        </a-spin>
      </a-drawer>
    </div>
  </a-spin>
</template>
<script>
import matchFun from '@comm/utils/matchFun'
import Upload from '@comm/upload/Upload'
import { mapState } from 'vuex'
export default {
  props: {
    // 是否需要隐藏，当设置为需要隐藏时如果查询出的团队数量只有一个，则默认选中且隐藏当前组件
    needHidden: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Upload
  },
  mounted () {
    localStorage.removeItem('teamId')
    this.initTeam()
  },
  data () {
    return {
      contentVisible: false,
      matchFun: matchFun,
      visible: false,
      loading: false,
      dataLoading: false,
      uploadingImg: false,
      curTeamId: this.choiceTeamId,
      teams: [],
      default_img: require('@comm/assets/join/null.png'),
      addImg: require('@comm/assets/join/add_bg.jpg'),
      programId: Number(this.$route.query.programId),
      teamName: null,
      form: {
        teamLogo: '',
        teamName: null,
        agencyId: this.$route.query.agencyId,
        programId: this.$route.query.programId
      },
      imgs: []
    }
  },
  computed: {
    ...mapState({
      joinAgency: state => state.join.joinAgency
    })
  },
  methods: {
    initTeam () {
      this.form.agencyId = this.$route.query.agencyId
      if (this.form.agencyId == null) {
        return
      }
      this.dataLoading = true
      let jonChannel = JSON.parse(localStorage.getItem('joinChannel'))
      let programIdParam = 0
      if (jonChannel.bigball.indexOf(this.programId) > -1) {
        programIdParam = this.programId
      }
      this.$api.join.getMatchTeam({agencyId: this.form.agencyId, programId: programIdParam}).then(res => {
        if (res.data && res.status === 0) {
          this.teams = res.data || []
          if (this.needHidden && this.teams.length === 1) {
            // 如果需要隐藏内容
            this.choiceTeam(this.teams[0].id)
            this.contentVisible = false
          } else {
            this.contentVisible = true
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err.msg || '请求返回错误')
      }).finally(() => {
        this.dataLoading = false
      })
    },
    // 重置选中的队伍
    resetChoicedTeam () {
      this.curTeamId = null
    },
    choiceTeam (teamId) {
      if (this.curTeamId === teamId) {
        this.curTeamId = null
        localStorage.removeItem('teamId')
      } else {
        this.curTeamId = teamId
        localStorage.setItem('teamId', this.curTeamId)
      }
      this.$emit('teamChecked', this.curTeamId)
    },
    showDrawer () {
      this.$nextTick(() => {
        if (this.imgs.length == 0) {
          this.imgs = [this.matchFun.randomNumFile('logo.jpg', this.joinAgency.agencyLogo)]
          this.form.teamLogo = this.joinAgency.agencyLogo
        }
      })
      this.visible = true
      this.uploadingImg = false
    },
    onClose () {
      this.visible = false
      this.uploadingImg = false
      this.form.teamLogo = localStorage.getItem('agencyLogo')
      this.teamName = null
    },
    submit () {
      if (this.form.teamLogo == null || this.form.teamLogo === '') {
        this.$message.error('请上传队伍logo')
        return
      }
      if (this.teamName == null || this.teamName === '') {
        this.$message.error('请指定队伍名称')
        return
      }
      if (this.teamName.indexOf('-') > -1) {
        this.$message.error('队伍名称中含有特殊字符“-”，请删除特殊字符')
        return
      }
      this.form.teamName = this.teamName
      this.loading = true
      this.$api.join.addMatchTeam(this.form).then(res => {
        if (res.status === 0) {
          this.initTeam()
          this.$message.success('提交成功')
          this.onClose()
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      }).catch(err => {
        this.$message.error(err.msg || '网络忙, 队伍添加失败')
      }).finally(() => {
        this.loading = false
      })
    },
    getTeamName (teamName) {
      if (teamName.indexOf('-') > -1) {
        return teamName.split('-')[1]
      } else {
        return teamName
      }
    },
    uploadSuccess (fileList) {
      if (fileList.length > 0) {
        this.form.teamLogo = fileList[0].url
        this.imgs = [this.matchFun.randomNumFile('logo.jpg', fileList[0].url)]
      } else {
        this.form.teamLogo = ''
        this.imgs = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .ant-tabs-bar {
    margin: 0px;
  }
  /deep/ .ant-drawer-body {
    padding: 20px;
  }
  .titleDiv {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    div {
      height: 25px;
      width: 5px;
      background-color: #b80000;
    }
    .title {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 0px;
      margin-left: 10px;
    }
  }
  .team {
    min-height: 145px;
    overflow: hidden;
    position: relative;
    border: 1px solid #ebedf0;
    background: #fff;
  }
  .leaderData {
    display: flex;
    padding: 10px;
    flex-wrap: wrap;
    .leader {
      height:120px;
      width:100px;
      margin:0 30px 0px 0;
      overflow:hidden;
      position:relative;
    }
    .coachHeader {
      height: 100px;
      width: 100px;
      border-radius: 5px;
    }
    .checked {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .drawerAddTeam {
    display: flex;
    justify-content:center ;
    align-items: flex-start;
    .imgContainer {
      height: 100px;
      width: 100px;
      margin-right: 30px;
      img {
        width: 100px;
        height: 100px;
      }
    }
    .operContainer {
      display: flex;
      justify-content:flex-end;
      margin-top:45px;
      .cancel {
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/team/Team.vue